import React from 'react';

import {SafetyNetModel} from '../../../../../models/api/safetyNetModel';
import {RuleEditorConditions} from '../../ruleEditorConditions';
import {StyledRuleEditorForm} from '../../ruleEditorForm';
import {RequiredTaggingEditorActions} from './hooks/useRequiredTaggingEditorState';
import {RequiredTaggingEditorActionsParams} from './requiredTaggingEditorActionsParams';
import {RequiredTaggingEditorState} from './state/requiredTaggingEditorState';

/*
 * Props.
 */

interface RequiredTaggingEditorFormProps {
  state: RequiredTaggingEditorState;
  actions: RequiredTaggingEditorActions;
  isEditing: boolean;
  safetyNets: ReadonlyArray<SafetyNetModel>;
}

/*
 * Component.
 */

export const RequiredTaggingEditorForm: React.FC<RequiredTaggingEditorFormProps> = ({
  state,
  actions,
  safetyNets,
  isEditing,
}) => (
  <StyledRuleEditorForm>
    <RuleEditorConditions
      conditions={state.ruleState.conditions}
      notDisplayingErrorCards={state.notDisplayingErrorCards}
      onAddCondition={actions.onAddCondition}
      onUpdateCondition={actions.onUpdateCondition}
      onDeleteCondition={actions.onDeleteCondition}
      onValidation={actions.onValidation}
    />
    <RequiredTaggingEditorActionsParams
      actions={state.requiredTaggingParamsState}
      safetyNets={safetyNets}
      notDisplayingErrorCards={state.notDisplayingErrorCards}
      onAddAction={actions.onAddActionParameter}
      onUpdateAction={actions.onUpdateActionParameter}
      onDeleteAction={actions.onDeleteActionParameter}
      onSetHiddenErrors={actions.onSetHiddenErrors}
      onValidation={actions.onValidation}
      isEditing={isEditing}
    />
  </StyledRuleEditorForm>
);
